(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["formobile-flash-sale"] && !Shopify.designMode) return;
  try {
    
(()=>{
const update=()=>document.querySelectorAll('[data-fm-clock]').forEach(clock=>{
const end=Date.parse(clock.dataset.end);if(!Number.isFinite(end))return;
const start=end-172800000;const now=Date.now();const before=now<start;const expired=now>=end;
let seconds=Math.max(0,Math.floor(((before?start:end)-now)/1000));
const root=clock.closest('.fm-flash');const title=clock.querySelector('[data-fm-clock-title]');title.textContent=before?root.dataset.fmOpens:expired?root.dataset.fmEnded:root.dataset.fmHurry;
clock.querySelector('[data-fm-h]').textContent=String(Math.floor(seconds/3600)).padStart(2,'0');
clock.querySelector('[data-fm-m]').textContent=String(Math.floor(seconds%3600/60)).padStart(2,'0');
clock.querySelector('[data-fm-s]').textContent=String(seconds%60).padStart(2,'0');
const status=clock.closest('.fm-flash').querySelector('[data-fm-status]');if(status)status.textContent=before?root.dataset.fmSoon:expired?root.dataset.fmClosed:root.dataset.fmOnly;
});
update();setInterval(update,1000);document.addEventListener('shopify:section:load',update);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formobile-privacy-weekend"] && !Shopify.designMode) return;
  try {
    
function expirePrivacyOffer(){document.querySelectorAll('[data-privacy-end]').forEach(el=>{if(Date.now()>=Date.parse(el.dataset.privacyEnd)){el.remove();}});}
expirePrivacyOffer();
setInterval(expirePrivacyOffer,15000);
document.addEventListener('shopify:section:load',expirePrivacyOffer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
